import {
  GROUPS,
  COMPONENT_TYPES,
  FORM_TYPES,
  PROP_TYPES,
  FIELD_NAME,
  TEXT_INPUT_PROPS,
} from "../core/component-types";

export const SEED_DATA = {
  name: "TextInput",
  tag: "TextInput",
  description: "An input field that allows users to type in data.",
  category: COMPONENT_TYPES.input,
  supports_list_render: false,
  layout: {
    height: 42,
    borderColor: "#eee",
    borderWidth: 1,
    borderRadius: 4,
    padding: 8,
  },
  props: {
    ...TEXT_INPUT_PROPS,
    clearButtonMode: {
      group: GROUPS.advanced,
      label: "Clear Button Mode",
      description:
        "Enables a button within the textInput to clear the data entered",
      editable: true,
      required: false,
      options: ["never", "while-editing", "unless-editing", "always"],
      defaultValue: null,
      formType: FORM_TYPES.flatArray,
      propType: PROP_TYPES.STRING,
    },
    clearTextOnFocus: {
      group: GROUPS.advanced,
      label: "Clear Text on Focus",
      description:
        "If true, clears the text field automatically when its focused.",
      editable: true,
      required: false,
      defaultValue: null,
      formType: FORM_TYPES.boolean,
      propType: PROP_TYPES.BOOLEAN,
    },
    enablesReturnKeyAutomatically: {
      group: GROUPS.advanced,
      label: "Enables Return Key Automatically",
      description:
        "If true, the keyboard disables the return key when there is no text and automatically enables it when there is (Default: false)",
      editable: true,
      required: false,
      defaultValue: null,
      formType: FORM_TYPES.boolean,
      propType: PROP_TYPES.BOOLEAN,
    },
    keyboardAppearance: {
      group: GROUPS.advanced,
      label: "Keyboard Appearance",
      description: "Determines color of the keyboard on iOS",
      editable: true,
      required: false,
      defaultValue: null,
      options: ["default", "light", "dark"],
      formType: FORM_TYPES.flatArray,
      propType: PROP_TYPES.STRING,
    },
    multiline: {
      group: GROUPS.basic,
      label: "Multiple Lines",
      description:
        "Allows multiple lines of input, useful for situations where the user may be typing in a lot of data.",
      editable: true,
      required: false,
      defaultValue: null,
      formType: FORM_TYPES.boolean,
      propType: PROP_TYPES.BOOLEAN,
    },
    numberOfLines: {
      group: GROUPS.basic,
      label: "Number of Lines",
      description:
        "Sets the number of lines for the input (Multiple Lines needs to be true)",
      editable: true,
      required: false,
      defaultValue: null,
      min: 0,
      step: 1,
      precision: 0,
      formType: FORM_TYPES.number,
      propType: PROP_TYPES.NUMBER,
    },
    scrollEnabled: {
      group: GROUPS.advanced,
      label: "Scroll Enabled",
      description:
        "If false, scrolling of the input will be disabled. Only works when Multiple Lines is true",
      editable: true,
      required: false,
      defaultValue: null,
      formType: FORM_TYPES.boolean,
      propType: PROP_TYPES.BOOLEAN,
    },
    spellcheck: {
      group: GROUPS.advanced,
      label: "Disable Spell Check",
      description:
        "If false, disables spell-check style (red underlines). Default comes from Auto Correct",
      editable: true,
      required: false,
      defaultValue: null,
      formType: FORM_TYPES.boolean,
      propType: PROP_TYPES.BOOLEAN,
    },
    textContentType: {
      group: GROUPS.advanced,
      label: "Text Content Type",
      description:
        "Give the keyboard and system about what it should do with the input. For example, if its an address, autofill from address book",
      editable: true,
      required: false,
      defaultValue: null,
      options: [
        "none",
        "URL",
        "addressCity",
        "addressCityAndState",
        "addressState",
        "countryName",
        "creditCardNumber",
        "emailAddress",
        "familyName",
        "fullStreetAddress",
        "givenName",
        "jobTitle",
        "location",
        "middleName",
        "name",
        "namePrefix",
        "nameSuffix",
        "nickname",
        "organizationName",
        "postalCode",
        "streetAddressLine1",
        "streetAddressLine2",
        "sublocality",
        "telephoneNumber",
        "username",
        "password",
      ],
      formType: FORM_TYPES.flatArray,
      propType: PROP_TYPES.STRING,
    },
    textBreakStrategy: {
      group: GROUPS.advanced,
      label: "Text Break Strategy",
      description:
        "(Android Only) Set the text break strategy. (Default: simple)",
      editable: true,
      required: false,
      defaultValue: null,
      options: ["simple", "highQuality", "balanced"],
      formType: FORM_TYPES.flatArray,
      propType: PROP_TYPES.STRING,
    },
    underlineColorAndroid: {
      group: GROUPS.advanced,
      label: "Underline color",
      description:
        "(Android Only) The color of the underline(the line underneath the text when finished typing.",
      editable: true,
      required: false,
      defaultValue: null,
      formType: FORM_TYPES.color,
      propType: PROP_TYPES.THEME,
    },
    fieldName: {
      ...FIELD_NAME,
      defaultValue: "textInputValue",
      handlerPropName: "onChangeText",
    },
  },
};
